import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function DuplicateWorkflowModal({
  isOpen,
  onClose,
  onAccept,
}) {
  if (!isOpen) return null;
  const { t } = useTranslation();
  const [duplicateWorkflow, setDuplicateWorkflow] = useState({
    name: '',
  });

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-xl relative border border-default">
        <h3 className="text-center text-xl mb-4 font-bold m-6 pb-6 border-b border-default">{ t('confirmations.createWorkflow') }</h3>
        <button onClick={onClose} type="button" className="absolute top-5 right-5 text-body bg-transparent hover:bg-neutral-tertiary hover:text-heading rounded-base text-sm w-9 h-9 ms-auto inline-flex justify-center items-center" data-modal-hide="popup-modal">
          <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6"/></svg>
        </button>
        <div className="ml-10 mr-10 mb-5">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Name
          </label>
          <input
            type="text"
            value={duplicateWorkflow.name}
            onChange={(e) => setDuplicateWorkflow({ ...duplicateWorkflow, name: e.target.value })}
            placeholder="e.g., Stamp Analysis"
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          />
        </div>
        <p className="mx-10 mb-5 text-sm text-gray-600 dark:text-gray-400">
          Workflow type and graph are copied from the original workflow.
        </p>

        <div className="flex justify-center gap-3 border-t border-default m-6 pt-6">
          <button
            onClick={() => onAccept(duplicateWorkflow.name)}
            className="px-4 py-2 bg-blue-600 rounded-xl text-white rounded hover:bg-blue-700"
          >
            {t('confirmations.createWorkflow')}
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded-xl hover:bg-gray-400"
          >
            {t('confirmations.closeModal')}
          </button>
        </div>
      </div>
    </div>
  );
}